import { Pipe, PipeTransform } from '@angular/core';
import {formatBytes} from '../../_core/utils/file.utils';

@Pipe({
  name: 'filesizeFormat'
})
export class FileSizeFormatPipe implements PipeTransform {
  transform(value: number, decimals = 2): any {
    return formatBytes(value, decimals);
  }
}
